module.exports = __webpack_public_path__ + "static/examp6-e5df0eba08eeb796cc0de624fdffeaa1.gif";